import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { WorkOrderNotificationService } from '../../../../ve.service';
import { FilterableService } from '../../../../filterable-service';

@Component({
  selector: 'ga-notification-dialog',
  templateUrl: './ga-notification-dialog.component.html',
  styleUrls: ['./ga-notification-dialog.component.scss']
})
export class GaNotificationDialogComponent implements OnInit {
  data: any = {};
  selectedOption: any;
  form: UntypedFormGroup;
  formBuilder: UntypedFormBuilder;
  contacts: any[];
  defaultContacts: any;
  service: WorkOrderNotificationService;
  contactsFilterableService = new FilterableService();

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<GaNotificationDialogComponent>,
    private readonly injector: Injector
  ) {
    this.service = this.injector.get(WorkOrderNotificationService);
    this.formBuilder = this.injector.get(UntypedFormBuilder);
    this.data = data;
    this.form = this.formBuilder.group({
      NotificationList: [],
      EmailNotes: []
    });
  }

  ngOnInit() {
    Promise.all([
      this.getDefaultContacts(),
      this.populateContactsList()
    ]);
  }

  onYesClick(): any {
    this.dialogRef.close(this.form.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getDefaultContacts(): Promise<any> {
    return this.service.read('/Module/VE_GA')
      .then(response => {
        if (response) {
          response.forEach(element => {
            if (element.WorkOrderStatusId === this.data.statusId) {
              const contacts = Object.assign([], element.ContactList);
              this.defaultContacts = contacts;
            }
          });
        }
      });
  }

  populateContactsList(): Promise<any> {
    return this.service.read('/ContactsForModule/VE_GA')
      .then(response => {
        this.contactsFilterableService.next(response);
      });
  }

  onValueChange(event: any) {
    if (event.length === 0 || !event) {
      this.form.get('EmailNotes').setValue('');
      this.form.get('EmailNotes').disable();
    } else {
      this.form.get('EmailNotes').enable();
    }
  }
}
